module.exports = __webpack_public_path__ + "img/Logo_Reporterre.4ca27bc0.svg";